'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dRole from "./app.data.-General-Practice-User-Role.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeInvolvement$$anon$8() {
}
export { $c_Lapp_data_GeneralPracticeInvolvement$$anon$8 as $c_Lapp_data_GeneralPracticeInvolvement$$anon$8 };
$c_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype.constructor = $c_Lapp_data_GeneralPracticeInvolvement$$anon$8;
/** @constructor */
function $h_Lapp_data_GeneralPracticeInvolvement$$anon$8() {
}
export { $h_Lapp_data_GeneralPracticeInvolvement$$anon$8 as $h_Lapp_data_GeneralPracticeInvolvement$$anon$8 };
$h_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype = $c_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype;
$c_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_GeneralPracticeInvolvement$$anon$8.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dRole.$m_Lapp_data_GeneralPracticeUserRole$().schema__Lsttp_tapir_Schema();
});
var $d_Lapp_data_GeneralPracticeInvolvement$$anon$8 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeInvolvement$$anon$8, "app.data.GeneralPracticeInvolvement$$anon$8", ({
  Lapp_data_GeneralPracticeInvolvement$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_GeneralPracticeInvolvement$$anon$8 as $d_Lapp_data_GeneralPracticeInvolvement$$anon$8 };
//# sourceMappingURL=app.data.-General-Practice-Involvement$$anon$8.js.map
